const labels = {
  QrCode: {
    'Ref: Page title': 'MyBus',
    'Ref: Hi': '你好',
    'Ref: Page content body': '到达和出发时，请务必扫描车辆二维码',
  },
};
export default labels;
